import { Container } from './styles';
import JohnnyGipson from '../../assets/JohnnyGipson.webp';
import python from '../../assets/python.svg';
import java from '../../assets/java.svg';
import wordpress from '../../assets/wordpress.svg';
import aws from '../../assets/aws.svg';
import htmlIcon from '../../assets/html-icon.svg';
import cssIcon from '../../assets/css-icon.svg';
import jsIcon from '../../assets/js-icon.svg';
// import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from '../../assets/react-icon.svg';
import typescriptIcon from '../../assets/typescript-icon.svg';
import vueIcon from '../../assets/vue-icon.svg';
import boostrapIcon from '../../assets/bootstrap-icon.svg';
import angularIcon from '../../assets/angular-icon.svg';
import langChainIcon from '../../assets/langchain-icon.svg';
import strandsIcon from '../../assets/strands-icon.svg';
import azureIcon from '../../assets/azure-icon.svg';
import gcpIcon from '../../assets/gcp-icon.svg';
import awsSapBadge from '../../assets/aws-certified-sap.png';
import ScrollAnimation from 'react-animate-on-scroll';

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            I'm an Enterprise Architecture leader with over 15 years of
            experience guiding organizations through complex technical
            transformations. I'm passionate about solving challenging problems
            and building scalable solutions that create real business impact.
          </p>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInLeft"
          delay={0.2 * 1000}
          style={{ marginTop: '2rem', marginBottom: '2rem' }}
        >
          <h2>What Drives Me</h2>
          <p>
            I specialize in modernizing legacy systems and architecting
            cloud-native solutions that align with business objectives. My
            greatest satisfaction comes from transforming fragmented systems
            into cohesive platforms that enable teams to excel and innovate.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <h2>My Approach</h2>
          <p>
            Great architecture exists at the intersection of technical
            excellence and business strategy. Whether I'm designing new
            frameworks, mentoring architects and developers, or presenting to
            C-suite executives, I focus on delivering practical solutions that
            drive measurable results.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={400}>
          <div className="education">
            <h3>Education:</h3>
            <h4> Master of Information Systems Management (MISM)</h4>
            <p>Keller School of Management, Long Beach, CA | Graduated: 2013</p>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={550}>
          <div className="experience">
            <h3>Recent Experience:</h3>
            <h4>Enterprise Architect</h4>
            <p>Daylight Transport | September 2015 - Present</p>
            <p>Cypress, CA</p>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.35 * 1000}>
          <div className="certification">
            <a
              href="https://www.credly.com/badges/c74f472a-68bd-4a38-abc0-187a6bb9182c/linked_in_profile"
              target="_blank"
              rel="noreferrer"
              aria-label="View AWS Certified Solutions Architect - Professional credential"
            >
              <img
                src={awsSapBadge}
                alt="AWS Certified Solutions Architect – Professional badge"
              />
            </a>
            <div className="certification-details">
              <h3>AWS Certified Solutions Architect – Professional</h3>
              <p>
                Validates advanced expertise in architecting and deploying
                secure, resilient, and cost-optimized workloads on AWS.
                Recognized for leading complex cloud transformations and scaling
                enterprise architectures.
              </p>
              <a
                className="credential-link"
                href="https://www.credly.com/badges/c74f472a-68bd-4a38-abc0-187a6bb9182c/linked_in_profile"
                target="_blank"
                rel="noreferrer"
              >
                View Credential
              </a>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </ScrollAnimation>
        <div className="hard-skills">
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={python} alt="python" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.11 * 1000}>
              <img src={java} alt="java" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={reactIcon} alt="React" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={typescriptIcon} alt="Typescript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.15 * 1000}>
              <img src={vueIcon} alt="Vue" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.16 * 1000}>
              <img src={wordpress} alt="Wordpress" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.17 * 1000}>
              <img src={aws} alt="aws" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.18 * 1000}>
              <img src={htmlIcon} alt="Html" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={cssIcon} alt="Css" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
              <img src={boostrapIcon} alt="bootstrap" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.21 * 1000}>
              <img src={angularIcon} alt="Angular" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.22 * 1000}>
              <img src={langChainIcon} alt="LangChain" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.23 * 1000}>
              <img src={strandsIcon} alt="Strands" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.24 * 1000}>
              <img src={azureIcon} alt="Azure" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.25 * 1000}>
              <img src={gcpIcon} alt="Google Cloud Platform" />
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation
          animateIn="fadeInRight"
          animateOnce
          offset={300}
          duration={0.6}
        >
          <img src={JohnnyGipson} alt="Johnny Gipson" />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
